/* src/app/core/modules/shared/components/footer/footer.component.scss */
/*# sourceMappingURL=/avvera/dev/footer.component.css.map */
